import { render, staticRenderFns } from "./violationEventSubmit.vue?vue&type=template&id=49624ac8&scoped=true"
import script from "./violationEventSubmit.vue?vue&type=script&lang=js"
export * from "./violationEventSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49624ac8",
  null
  
)

export default component.exports